//@flow
import Collection from '../../Utils/Collection/collection';
import OrderModel from './orderModel';
import subDays from 'date-fns/sub_days';

import type { OrderObject } from './orderModel';

export default class OrderCollection extends Collection<OrderObject, OrderModel> {
  __modelClass() {
    return OrderModel;
  }

  getProcessingOrders():OrderModel[] {
    return this._getModelsByAttribute('status', 'processing');
  }

  getLastOrder():?OrderModel {
    return this.models.length ? this.models[this.models.length-1] : undefined;
  }

  getOrdersInTransit(today:Date):OrderModel[] {
    const inTransit = (order => {
      const inTransitThreshold = subDays(today, 14);
      return order.getStatus() === 'complete' && (inTransitThreshold <= order.getDateCreated());
    });
    return this._getModelsByVerb(inTransit);
  }
}
